import ActionsDetail from '@/components/actions-detail/index.vue';

const components = {
    ActionsDetail
};

export default components;
